import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import { Icon, IconButton } from '@st-operations/uikit/src/v2/index.js'

import './styles.scss'

const SUPPORTED_EXTENSIONS = ['xlsx', 'xls', 'csv']

const FileInput = ({ label, onAddFile, fileName, extensions }) => {
  const [file, setFile] = useState(fileName ? { name: fileName } : null)

  useEffect(() => {
    onAddFile(file)
  }, [file])

  const handleAddFile = (file) => {
    if (!extensions.includes(file.name.split('.').splice(-1)[0])) {
      toast.error('The extension you tried to upload is not supported')
      return
    }
    setFile(file)
  }

  const handleDrag = (event) => {
    event.preventDefault()
    event.stopPropagation()
  }

  const handleDrop = (event) => {
    event.preventDefault()
    event.stopPropagation()

    if (event.dataTransfer.items && event.dataTransfer.items.length > 0) {
      const file = event.dataTransfer.files[0]
      handleAddFile(file)
      event.dataTransfer.clearData()
    }
  }

  const handleRemoveFile = () => setFile(null)

  const handleFileChoose = (event) => {
    handleAddFile(event.target.files[0])
  }

  return (
    <div className="file-input">
      {label && <p className="file-input__text">{label}</p>}
      <Choose>
        <When condition={file}>
          <div className="file-input__file-container">
            <div className="file-input__file">
              <Icon icon="filecsv" type="fill" color="#13682B" width="48px" height="48px" />
              <div>
                <p className="file-input__file-title">{file.name}</p>
                <If condition={file.size}>
                  <p className="file-input__file-size">{file.size / 100} KB</p>
                </If>
              </div>
            </div>
            <IconButton
              onClick={handleRemoveFile}
              className="file-input__delete"
              iconProps={{ icon: 'delete', type: 'fill', color: '#3d3d3d', width: 16, height: 16 }}
            />
          </div>
        </When>
        <Otherwise>
          <label onDragOver={handleDrag} onDrop={handleDrop} className="file-input__label">
            <Icon icon="download" type="fill" color="#13682B" width="64px" height="64px" />
            <div>
              <p className="file-input__title">
                <b>Choose a file</b> or drag it here
              </p>
              <p className="file-input__description">Make sure your file is in .CSV format</p>
              <input
                accept={extensions.map((ext) => `.${ext}`).join(',')}
                onChange={handleFileChoose}
                type="file"
              />
            </div>
          </label>
        </Otherwise>
      </Choose>
    </div>
  )
}

FileInput.propTypes = {
  onAddFile: PropTypes.func,
  label: PropTypes.string,
  fileName: PropTypes.string,
  extensions: PropTypes.array.isRequired,
}

FileInput.defaultProps = {
  onAddFile: () => {},
  label: '',
  fileName: '',
  extensions: SUPPORTED_EXTENSIONS,
}

export default React.memo(FileInput)
